import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ServerResponse, TreetopPropertiesProvider } from 'shared/util-common';

import { Workflow } from '@treetop/shared/model';

@Injectable({ providedIn: 'root' })
export class WorkflowHttpService {
  private http = inject(HttpClient);
  private readonly baseUrl = `${TreetopPropertiesProvider.properties.baseUrl}api/workflows`;

  public getWorkflows(searchTerm: string, page: number): Observable<ServerResponse<Workflow>> {
    const params = new HttpParams().set('search', searchTerm).set('page', page.toString());
    return this.http.get<ServerResponse<Workflow>>(`${this.baseUrl}/lookup`, { params });
  }
}
